// Fail closed against old deployments which ignore the new server filter.
export const filterMedia = (items, scriptId) => scriptId ? items.filter(item => item.documentId === scriptId) : items;

// Saving may fail or the scene list may change; never silently choose another scene.
export const prepareMedia = async (beforeGenerate, scriptId, sceneId, scenes) => {
  if (!beforeGenerate) return;
  const savedScenes = await beforeGenerate(scriptId);
  const selected = scenes.find(scene => scene.id === sceneId);
  if (!selected || JSON.stringify(savedScenes) !== JSON.stringify(scenes)) {
    throw new Error('The saved scene list changed. Close and reopen this tool, then select the scene again. Nothing was generated.');
  }
};